import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import { useDispatch } from 'react-redux';



const ImageView = ( props ) => {
        const dispatch = useDispatch();
    return ( 
          <div>
        <div style={{ width:props.width,zIndex:1,position: 'absolute',}} className='imageOptions'>
           <center>
<Link to="/imageViewer" onClick={()=> dispatch({type:props.setImage}) }>
<button>
View
</button>
</Link>
<Link to="/aboutImageViewer" onClick={()=> dispatch({type:props.setImage}) } >
<button>
about image
</button>
</Link>
</center>
        </div>
<motion.img   
transition={{ duration: 1,}}
drag="x"

dragConstraints={{ left:1,right: 100,}}
whileTap={{scale:1.2}}
className={props.className} style={{height:props.height,width:props.width,zIndex:1,}} src={props.src} />
</div>
 );
}
 
export default ImageView;